<template lang="html">
    <div class="basic-info">
        <!--变更后保单信息-->
        <div v-if="isShow('bghbdxx')">
            <Slogan theTitle="变更后保单信息"/>
            <van-cell-group>
                <!--待出函-->
<!--                <div v-if="cDbzt == 4">
                    <van-cell value="保单号、保函、电子保单正在生成中，您请稍后再查看！"/>
                </div>-->
                <!--已出函-->
                <div v-if="cDbzt == 5 || cDbzt == 8 || cDbzt == 9|| cDbzt == 11|| cDbzt == 12">
                    <van-field
                        v-model="bdData.cBdh"
                        clearable
                        readonly
                        label="保单号"
                    ></van-field>
                    <van-field v-if="cDbzt != 12 && showDownLoadBd"
                        readonly
                        label="电子保单"
                    >
                        <!--                        <span  @click="downloadBd">电子保单.pdf</span>-->
                        <van-button class="no-border" slot="button" size="small" plain type="info" @click="downloadBd">电子保单.pdf</van-button>
                    </van-field>
                    <van-field v-if="cDbzt != 12"
                        readonly
                        label="电子保函"
                    >
                        <!--                        <span  @click="downloadBh">电子保函.pdf</span>-->
                        <van-button class="no-border" slot="button" size="small" plain type="info" @click="downloadBh">电子保函.pdf</van-button>
                    </van-field>
                </div>
            </van-cell-group>
        </div>

        <!--审核信息-->
        <div v-if="isShowbgshxx&&isShow('bgshxx')">
            <Slogan theTitle="变更审核信息"/>
            <van-cell-group>
                <!--审核中-->
                <div v-if="!dbbgshjlData.nShjg">
                    <van-cell value="您提交的申请正在审核中，请您耐心等待"/>
                    <van-field
                        v-model="dbbgshjlData.cShr"
                        clearable
                        readonly
                        label="审核人"
                    ></van-field>
                    <van-field
                        v-model="dbbgshjlData.cShrlxfs"
                        clearable
                        readonly
                        label="审核人联系方式"
                    ></van-field>
                </div>
                <div v-if="['1','2','3'].includes(String(dbbgshjlData.nShjg))">
                    <van-field
                        v-model="dbbgshjlData.nShjgtxt"
                        clearable
                        readonly
                        label="审核结果"
                    ></van-field>
                    <van-field
                        v-if="['2'].includes(String(dbbgshjlData.nShjg))"
                        v-model="dbbgshjlData.cShbtgyy"
                        clearable
                        readonly
                        label="审核不通过原因"
                        @click="toastJointCcxx(dbbgshjlData.cShbtgyy)"
                    ></van-field>
                    <van-field
                        v-model="dbbgshjlData.cShr"
                        clearable
                        readonly
                        label="审核人"
                    ></van-field>
                    <van-field
                        v-model="dbbgshjlData.cShrlxfs"
                        clearable
                        readonly
                        label="审核人联系方式"
                    ></van-field>
                    <van-field
                        v-model="dbbgshjlData.dtShrq"
                        clearable
                        readonly
                        label="审核日期"
                    ></van-field>
<!--                    变更次数大于0，才会显示对应的补退类型和补退金额-->
                    <template v-if="dbbgshjlData.nBgcs > 0">
                        <van-field
                            v-model="dbbgshjlData.nBtlxText"
                            clearable
                            readonly
                            label="补退类型"
                        ></van-field>
<!--                        不涉及补退类型的时候不需要展示补退金额 -->
                        <van-field v-if="dbbgshjlData.nBtlx > 0"
                            v-model="dbbgshjlData.nBtjeText"
                            clearable
                            readonly
                            label="补退金额"
                        ></van-field>
                    </template>
                </div>
            </van-cell-group>
        </div>

        <!--保单信息-->
        <div v-if="isShow('bdxx')">
            <!--<Slogan theTitle="保单信息" />-->
            <info-title
                title-content="保单信息"
                vertical-line="true"
                :title-button="isShowTB?'查看退保信息':''"
                @buttonClick="buttonClick"
            />
            <van-cell-group>
                <!--待出函-->
                <div v-if="cDbzt == 4">
                    <van-cell value="保单号、保函、电子保单正在生成中，您请稍后再查看！"/>
                </div>
                <!--已出函-->
                <div v-if="cDbzt == 5 || cDbzt == 8 || cDbzt == 9|| cDbzt == 11|| cDbzt == 12">
                    <van-field
                            v-model="bdData.cBdh"
                            clearable
                            readonly
                            label="保单号"
                    ></van-field>
                    <van-field v-if="showDownLoadBd"
                            readonly
                            label="电子保单"
                    >
<!--                        <span  @click="downloadBd">电子保单.pdf</span>-->
                        <van-button class="no-border" slot="button" size="small" plain type="info" @click="downloadBd">电子保单.pdf</van-button>
                    </van-field>
                    <van-field
                            readonly
                            label="电子保函"
                    >
<!--                        <span  @click="downloadBh">电子保函.pdf</span>-->
                        <van-button class="no-border" slot="button" size="small" plain type="info" @click="downloadBh">电子保函.pdf</van-button>
                    </van-field>
                </div>
            </van-cell-group>
        </div>
        <!--交费信息-->
        <div v-if="isShow('jfxx')">
            <Slogan theTitle="交费信息"/>
            <van-cell-group>
                <div>
                    <van-field
                        v-model="dbjfshxx.njfztTxt"
                        clearable
                        readonly
                        label="交费状态"
                    ></van-field>
                    <van-field
                        v-if="[1,11].includes(dbjfshxx.njfzt)"
                        v-model="dbjfshxx.jfsj"
                        clearable
                        readonly
                        label="交费日期"
                    ></van-field>
                    <van-field
                        v-if="[1].includes(dbjfshxx.njfzt)"
                        v-model="dbjfshxx.jfje"
                        clearable
                        readonly
                        label="交费金额"
                    ></van-field>
                </div>
            </van-cell-group>
        </div>
        <!--审核信息-->
        <div v-if="isShow('shxx')">
            <Slogan theTitle="审核信息"/>
            <van-cell-group>
                <!--审核中-->
                <div v-if="cDbzt == 2">
                    <van-cell value="您提交的申请正在审核中，请您耐心等待。"/>
                    <van-field
                        v-model="dbjfshxx.shren"
                        clearable
                        readonly
                        label="审核人"
                    ></van-field>
                    <van-field
                        v-model="dbjfshxx.shrentel"
                        clearable
                        readonly
                        label="审核人联系方式"
                    ></van-field>
                </div>
                <div v-if="[3,4,5,6,8,9,11,12,13].includes(parseInt(cDbzt))&&[1,2,3].includes(parseInt(dbjfshxx.nshjg))">
                    <van-field
                        v-model="dbjfshxx.nshjgTxt"
                        clearable
                        readonly
                        label="审核结果"
                    ></van-field>
                    <van-field
                        v-if="[2].includes(parseInt(dbjfshxx.nshjg))"
                        v-model="dbjfshxx.shyj"
                        clearable
                        readonly
                        label="审核不通过原因"
                    ></van-field>
                    <van-field
                        v-if="[3].includes(parseInt(dbjfshxx.nshjg))"
                        v-model="dbjfshxx.shyj"
                        clearable
                        readonly
                        label="退回原因"
                    ></van-field>
                    <van-field
                        v-model="dbjfshxx.shsj"
                        clearable
                        readonly
                        label="审核日期"
                    ></van-field>
                    <van-field
                        v-model="dbjfshxx.shren"
                        clearable
                        readonly
                        label="审核人"
                    ></van-field>
                    <van-field
                        v-model="dbjfshxx.shrentel"
                        clearable
                        readonly
                        label="审核人联系方式"
                    ></van-field>

                </div>
            </van-cell-group>
        </div>
        <!--取消担保信息-->
        <div v-if="isShow('qxdb')">
            <Slogan theTitle="取消担保信息"/>
            <van-cell-group>
                <van-field
                        clearable
                        readonly
                        label="取消结果"
                        value="已取消"
                ></van-field>
                <van-field
                        v-model="qxdbData.dtQxsj"
                        clearable
                        readonly
                        label="取消日期"
                ></van-field>
            </van-cell-group>
        </div>
        <!--担保基本信息-->
        <div>
            <Slogan theTitle="担保基本信息"/>
            <van-cell-group>
                <van-field
                        v-model="basicData.cFymc"
                        clearable
                        readonly
                        label="申请法院"
                        @click="toastJointCcxx(basicData.cFymc)"
                ></van-field>
                <van-field
                        v-model="basicData.cBxgsmc"
                        clearable
                        readonly
                        label="担保机构"
                        @click="toastJointCcxx(basicData.cBxgsmc)"
                >
                </van-field>
                <van-field
                        v-model="basicData.cBqlx"
                        readonly
                        clickable
                        label="保全类型"
                ></van-field>
                <van-field
                        v-model="basicData.cBqlb"
                        readonly
                        clickable
                        label="保全类别"
                ></van-field>
                 <van-field
                        v-if="bqlb == 2"
                        v-model="basicData.cAhAjlxdz"
                        readonly
                        clickable
                        label="案件类型"
                ></van-field>
                <van-field
                        v-if="bqlb == 2"
                        v-model="basicData.cAh"
                        readonly
                        clickable
                        label="案号"
                        @click="toastJointCcxx(basicData.cAh)"
                ></van-field>
                <van-field
                        v-if="bqlb == 2  && (basicData.nAjlx == 1 || basicData.nAjlx == 2)"
                        v-model="basicData.cAy"
                        readonly
                        clickable
                        label="案由"
                        @click="toastJointCcxx(basicData.cAy)"
                ></van-field>
                <van-field
                        v-if="bqlb == 2 && basicData.nAjlx == 6"
                        v-model="cAyzt"
                        readonly
                        clickable
                        :label="ayLabel_1"
                        @click="toastJointCcxx(cAyzt)"
                ></van-field>
                <van-field
                        v-if="bqlb == 2 && basicData.nAjlx == 6"
                        v-model="cAyxw"
                        readonly
                        clickable
                        :label="ayLabel_2"
                        @click="toastJointCcxx(cAyxw)"
                ></van-field>
                <van-field
                        v-if="bqlb == 2 && basicData.nAjlx == 6 && cAhNf >= 2021"
                        v-model="cXzaymc"
                        readonly
                        clickable
                        label="行政案由名称"
                        @click="toastJointCcxx(cXzaymc)"
                ></van-field>
                <van-field
                        v-if="bqlb == 1"
                        v-model="basicData.cFsqj"
                        readonly
                        clickable
                        label="非诉期间"
                        @click="toastJointCcxx(basicData.cFsqj)"
                ></van-field>
                <van-field
                        v-model="basicData.nSqbqje"
                        readonly
                        clickable
                        label="申请担保金额(元)"
                        @click="toastJointCcxx(basicData.nSqbqje)"
                ></van-field>
                <van-field
                        v-model="basicData.nDbfy"
                        readonly
                        label="建议担保费(元)"
                        class="amount-ipt"
                        @click="toastJointCcxx(basicData.nDbfy)"
                ></van-field>
                <van-field
                        v-model="basicData.cFl"
                        readonly
                        label="费率(‰)"
                        class="amount-ipt"
                ></van-field>
                <van-field
                        v-model="basicData.cTjr"
                        readonly
                        class="amount-ipt"
                        label="提交人"
                ></van-field>
                <van-field
                        v-model="basicData.dtTjsj"
                        readonly
                        class="amount-ipt"
                        label="提交日期"
                ></van-field>
                <van-field
                        v-model="basicData.cTjrlx"
                        readonly
                        label="提交人身份"
                ></van-field>
                <van-field
                    v-model="basicData.cClerkNo"
                    readonly
                    label="咨询员编号"
                    @click="toastJointCcxx(basicData.cClerkNo)"
                ></van-field>
            </van-cell-group>
        </div>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'
    import InfoTitle from '../../../components/common/InfoTitle';
    import wx from 'weixin-js-sdk'
    import { Toast } from 'vant';
    import {
        typeBqlb,
        typeTjrlx,
        typeFsccFsqj,
        typeAjlx,
        typeBqlx,
        typeShjg,
        typeJfzt,
        typeBtlx
    } from '../../../filters/index'
    import {getTreeDataById} from "../../../utils/common";
    import {getCxtb} from '../../../api/common';
    import {getToken} from '../../../utils/auth';
    import {getDbbgBgshjl, getShxx, getXzbdqx} from '../../../api/guarantee'


    export default {
        components: {
            Slogan,InfoTitle
        },
        // 注入
        // 担保id
        inject: ['dbid'],
        data() {
            return {
                isShowTB:false,
                isGetTB:false,
                basicData: {
                    cFymc: '', // 申请法院
                    cBxgsmc: '', // 担保机构
                    cBqlb: '', // 保全类别
                    cBqlx: '', // 保全类型
                    nAjlx: '', // 保全类型
                    nSqbqje: '', // 申请保全金额
                    nDbfy: '', // 担保费用
                    cFl: '', // 担保费率
                    cTjr: '', // 提交人
                    cTjrlx: '', // 提交人身份
                    cClerkNo:"",//咨询员编号
                    cFsqj: '',//非诉期间
                    cAh: "",//案号
                    cAy: "",//案由
                    dtTjsj:"",
                    cAhAjlxdz: ""//案件类型
                },
                cDbzt: '', // 担保状态 1待提交,2待审核,3待缴费,4待出函, 5已出函, 6审核不通过, 7取消担保
                // 保单信息
                bdData: {
                    cBdh: '', // 保单号
                    dzbdUrl: '', // 电子保单下载地址
                    dzbhUrl: '', // 电子保函下载地址
                },
                // 交费信息
                jfData: {
                    dtZfsj: '', // 支付时间, 为空则未支付
                    nZfjg: '', // 支付结果
                },
                // 审核信息
                shData: {
                    // cDbzt 2时待审核, 审核中, cDbzt 3时待缴费, 审核通过, cDbzt 6时审核不通过
                    dtShsj: '', // 审核日期
                    cShyj: '', // 审核不通过原因
                },
                qxdbData: {
                    // cDbzt7 取消担保
                    dtQxsj: '', // 取消担保日期
                },
                bqlb: "",
                cAyzt:'',
                cAyxw:'',
                cXzaymc:'',
                cAhNf:'',

                ayLabel_1:'',
                ayLabel_2:'',

                dbbgshjlData:{},
                dbjfshxx:{
                    njfzt:'',
                    njfztTxt:'',
                    jfsj:'',
                    jfje:'',

                    nshjg:'',
                    nshjgTxt:'',
                    shyj:'',
                    cShyj:'',
                    shsj:'',
                    shren:'',
                    shrentel:''
                },
               /* bgshxx:{
                    nShjg:'',
                    cShbtgyy:'',
                    cShr:'',
                    cShrlxfs:'',
                    dtShrq:''
                }*/
                // 是否有下载保单的权限
                showDownLoadBd:false
            }
        },
        computed:{
            isShowbgshxx(){
                console.log('--isShowbgshxx 123',Object.keys(this.dbbgshjlData).length);
                if(Object.keys(this.dbbgshjlData).length>0){
                    return true;
                }else{
                    return false;
                }
            }
        },
        methods: {
            buttonClick(){
                console.log('--buttonClick 453');
                this.$router.push("/tuiBaoInfo");
            },
            toastJointCcxx(value){
                Toast(value);
            },
            //下载保单
            downloadBd(){
                let id = window.sessionStorage.getItem("dbid");
                wx.miniProgram.navigateTo({
                    url: '/pages/download/download?id='+id+'&token='+getToken()
                })
            },
            //下载保函
            downloadBh(){
                let id = window.sessionStorage.getItem("dbid");
                wx.miniProgram.navigateTo({
                    url: '/pages/downloadBh/downloadBh?id='+id+'&token='+getToken()
                })
            },
            getGuaranteeBasic() {
                let Id = window.sessionStorage.getItem("dbid");
                this.$axios.get('ssbq/api/ssdb/dbjbxx' + "?time=" + new Date().getTime() + "&dbid=" + Id).then(res => {

                    let {cAhNf, nAjlx} = res.data;
                    var key = (Number(cAhNf) >= 2021) ? 2021 : 2020;
                    if (key === 2020) {
                        this.ayLabel_1 = Number(nAjlx) === 6 ? '案由(主体类型)' : '案由';
                        this.ayLabel_2 = '案由(行为种类)';
                    } else {
                        this.ayLabel_1 = Number(nAjlx) === 6 ? '行政主体类型' : '案由';
                        this.ayLabel_2 = '行政案由';
                    }

                    this.bqlb = res.data.cBqlb;
                    this.basicData.cFymc = res.data.cFymc;
                    this.basicData.cBxgsmc = res.data.cBxgsmc;
                    this.basicData.cBqlb = typeBqlb(res.data.cBqlb);
                    this.basicData.cBqlx = typeBqlx(res.data.cBqlx);
                    this.basicData.nSqbqje = res.data.nSqbqje;
                    this.basicData.nDbfy = res.data.nDbfy;
                    this.basicData.cFl = res.data.cFl * 1000;
                    this.basicData.cTjr = res.data.cTjr;
                    this.basicData.cAy = res.data.cAy;
                    this.basicData.cAh = res.data.cAh
                    this.basicData.nAjlx = res.data.nAjlx
                    this.basicData.cAhAjlxdz = typeAjlx(res.data.nAjlx);
                    this.basicData.dtTjsj = res.data.dtTjsj;
                    this.basicData.cFsqj = typeFsccFsqj(res.data.cFsqj);
                    this.basicData.cTjrlx = typeTjrlx(res.data.cTjrlx);
                    this.basicData.cClerkNo = res.data.cClerkNo;

                    this.basicData.nSfbgwc=res.data.nSfbgwc;
                    // this.basicData.nSfbgwc=0;


                    this.cAhNf = cAhNf;
                    let data = res.data;
                    // 保单状态
                    this.cDbzt = data.cDbzt;
                    // this.cDbzt = '5';
                    // 保单号
                    this.bdData.cBdh = data.cBdh;
                    // 电子保单下载
                    this.bdData.dzbdUrl = "/commonapi/api/policy/zdz/download?type=bd&dbid=" + Id;
                    // 电子保函下载
                    this.bdData.dzbhUrl = "/commonapi/api/policy/zdz/download?type=bh&dbid=" + Id;
                    // // 缴费时间
                    // this.jfData.dtZfsj = data.dtZfsj;
                    // // 缴费结果
                    // this.jfData.nZfjg = data.nZfjg;
                    // 审核日期
                    this.shData.dtShsj = data.dtShsj;
                    // 审核意见, 未通过原因
                    this.shData.cShyj = data.cShyj;
                    // 取消担保时间
                    this.shData.dtQxsj = data.dtQxsj;

                    if(nAjlx === 6){
                        let ay = res.data.cAy.split(";");
                        this.cAyzt = ay[0];
                        /*let cAyzlarr = [];
                        ay.map((item, index) => {
                            if(index != 0){
                                cAyzlarr.push(item)
                            }
                        })*/
                        if(key===2021){
                            this.$axios.get('ssbq/api/bqsqs/new/ay', {})
                                .then(res => {
                                    console.log('--initAyList');
                                    var dataList=res.data['2021']['62']['0'].children;
                                    var list={};
                                    getTreeDataById(dataList,list);

                                    var ids=data.cAyxzxw;
                                    ids=ids.slice(ids.length-1)===','?ids.slice(0,ids.length-1).split(','):ids.slice(0,ids.length).split(',');
                                    var texts='';
                                    ids.map(item=>{
                                        texts+=list[item]+';';
                                    });
                                    this.cAyxw = texts;
                                    //this.basicData.cAyxzxwName = texts;
                                });
                        }else{
                            this.cAyxw = ay.join(";")
                        }
                        this.cXzaymc = res.data.cXzaymc;
                    }

                })
            },
            searchDBBGSHJL:function(){
                getDbbgBgshjl(window.sessionStorage.getItem("dbid")).then(response=>{
                    console.log('--searchDBBGSHJL 111',response);
                    if(response.code===200&&response.data.length>0){
                        let {data} = response
                        this.dbbgshjlData=data[0];
                        this.dbbgshjlData.nShjgtxt=typeShjg(this.dbbgshjlData.nShjg);
                        if (this.dbbgshjlData.nBgcs > 0) {
                            // 补退类型文本
                            this.dbbgshjlData.nBtlxText = typeBtlx(this.dbbgshjlData.nBtlx);
                            // 补退金额文本
                            this.dbbgshjlData.nBtjeText = `${this.dbbgshjlData.nBtje}元`;
                        }
                    }else{
                        this.dbbgshjlData={};
                    }
                    console.log('--searchDBBGSHJL 22',this.dbbgshjlData);
                });
            },
            getDbShxx:function(){
                getShxx(window.sessionStorage.getItem("dbid")).then(res=>{
                    console.log('--getShxx 123',res);
                    if(res.code===200){
                        /*var dbjfshxx={
                            njfzt:res.data.njfzt,
                            njfztTxt:typeJfzt(res.data.njfzt),
                            jfsj:res.data.jfsj,
                            jfje:res.data.jfje+'元'

                        };
                        this.dbjfshxx=dbjfshxx;*/

                        //交费信息
                        this.dbjfshxx.njfzt=res.data.njfzt;
                        this.dbjfshxx.njfztTxt=typeJfzt(res.data.njfzt);
                        this.dbjfshxx.jfsj=res.data.jfsj;
                        this.dbjfshxx.jfje=res.data.jfje+'元';

                        //审核信息
                        this.dbjfshxx.nshjg=res.data.nshjg;
                        this.dbjfshxx.nshjgTxt=typeShjg(res.data.nshjg);

                        this.dbjfshxx.shyj=res.data.shyj;
                        this.dbjfshxx.cShyj=res.data.cShyj;
                        this.dbjfshxx.shsj=res.data.shsj;
                        this.dbjfshxx.shren=res.data.shren;
                        this.dbjfshxx.shrentel=res.data.shrentel;

                        // this.dbjfshxx=res.data;
                    }
                })
            },
            // 获取下载保单权限
            getXzbdqx() {
                getXzbdqx({dbid: sessionStorage.getItem("dbid")}).then(res => {
                    console.log('--getXzbdqx 123', res);
                    if (res.code === 200) {
                        this.showDownLoadBd = res.data;
                    }
                })
            },
            isShow: function (type) {
                // 变更后保单信息
                if(type==='bghbdxx'){
                    if(this.cDbzt==='12' ||(this.cDbzt==='5'&&this.basicData.nSfbgwc > 0)){
                        return true;
                    }else{
                        return false
                    }
                }

                // 变更审核信息
                if (type === "bgshxx") {
                   if(['5','11','12'].includes(String(this.cDbzt))&&Object.keys(this.dbbgshjlData).length){
                       return true;
                   }else{
                       return false;
                   }
                }

                // 取消担保后详情页面展示  取消担保信息项 + 取消时保单状态对应的信息项(有可能是待审核或待交费)
                // 即涉及 2待审核, 3待交费状态的数据项需要判断一下 7取消状态是否显示
                // 保单信息
                if (type === "bdxx") {
                    if(!(this.cDbzt==='12'||(this.cDbzt==='5'&&this.basicData.nSfbgwc > 0))){
                        if(!this.isGetTB&&[5,8,9].includes(Number(this.cDbzt))){
                            this.isGetTB=true;
                            getCxtb({dbid:sessionStorage.getItem("dbid")}).then((res) => {
                                console.log('--cxkp',res);
                                (res.code===200)&&res.data&&(this.isShowTB=true);
                            });
                        }
                        return [4, 5, 8, 9,11,12].includes(Number(this.cDbzt));
                    }else{
                        return false;
                    }


                }
                // 交费信息
                if (type === "jfxx") {
                    if (this.cDbzt != 7) {
                        return [3, 4, 5, 8, 9, 11, 12].includes(Number(this.cDbzt));
                    } else {
                        return [3, 4, 5, 8, 9, 11, 12].includes(this.getStatusOnQxdb());
                    }
                }
                // 审核信息
                if (type === "shxx") {
                    if (this.cDbzt != 7) {
                        return [2, 3, 4, 5, 6, 8 ,9,11,12,13].includes(Number(this.cDbzt));
                    } else {
                        // 审核信息2, 3状态都显示, 即取消担保后详情一定显示此项
                        return true;
                    }
                }
                // 取消担保信息
                if (type === "qxdbxx") {
                    // 保单状态处于取消状态就显示取消担保信息
                    return this.cDbzt == 7;
                }
                return false;
            },
            getStatusOnQxdb: function () {
                // 获取取消担保时, 保单是处于 2待审核还是 3待交费
                if (!this.shData.dtShsj) {
                    // 审核时间为空, 处于待审核状态取消担保
                    return 2;
                } else {
                    // 有审核时间, 此时一定是审核通过, 即处于待交费状态
                    return 3;
                }
            }
        },
        mounted() {
            this.getGuaranteeBasic()
            this.searchDBBGSHJL();
            this.getDbShxx();
            this.getXzbdqx();
        }
    }
</script>

<style lang="less" scoped>
    .van-button--info{
        border: none !important;
    }
    /deep/.van-button--small{
        font-size: 14px !important;
    }
</style>
